<template>
  <div>
    <div class="leave-list-wrap">
      <!-- <div class="leave-list-title">进出审批</div> -->
      <div class="leave-list" v-if="list.length > 0">
        <div
          class="leave-list-item"
          v-for="item in list"
          :key="item.id"
          @click="clickLeaveDetail(item)"
        >
          <div class="cause flex flex-b flex-vc">
            <span>{{ item.parentName }}</span>
            <van-tag
              plain
              type="success"
              v-if="item.leaveState == 1"
              size="medium"
              >已同意</van-tag
            >
            <van-tag
              plain
              type="primary"
              size="medium"
              v-if="item.leaveState == 0"
              >待审批</van-tag
            >
            <van-tag
              plain
              type="danger"
              size="medium"
              v-if="item.leaveState == 2"
              >已拒绝</van-tag
            >
          </div>
          <div class="date">
            <span>开始时间：</span
            ><span>{{ item.leaveTime }} {{ item.leaveBeginTime }}</span>
          </div>
          <div class="date">
            <span>结束时间：</span
            ><span>{{ item.leaveTime }} {{ item.leaveEndTime }}</span>
          </div>
          <div class="date">
            <span>进出人员：</span>
            <span v-for="(v, index) in item.childDTOS">
              {{ v.name }}
              <span
                v-if="
                  item.childDTOS.length > 0 &&
                    index !== item.childDTOS.length - 1
                "
                >、</span
              >
            </span>
          </div>
          <div class="note">
            <span style="width: 4rem; display: inline-block; text-align: right;"
              >申请原因：</span
            ><span>{{ item.remark }}</span>
          </div>
          <!-- <div class="c-left">
            <div class="flex">
              <div style="margin-right: 1rem;">
                <span>家长：</span><span>{{ item.parentName }}</span>
              </div>
              <div>
                <span>孩子：</span
                ><span v-for="(v, index) in item.childDTOS"
                  ><span>{{ v.name }}</span
                  ><span
                    v-if="
                      item.childDTOS.length > 0 &&
                      index !== item.childDTOS.length - 1
                    "
                    >、</span
                  ></span
                >
              </div>
            </div>
            <div style="margin-top: 0.8rem;">
              <div style="margin-right: 1rem;">
                <span>时间：</span>{{ item.leaveTime
                }}<span>
                  {{ item.leaveBeginTime }} - {{ item.leaveEndTime }}</span
                >
              </div>
            </div>
          </div> -->
          <!-- <div
            class="c-right"
            @click.stop="handleAudit(item)"
            v-if="item.pickUpState == 0"
          >
            审批
          </div> -->
          <!-- <van-tag plain type="success" v-if="item.leaveState == 1"
            >已同意</van-tag
          >
          <van-tag plain type="primary" v-if="item.leaveState == 0"
            >待审批</van-tag
          >
          <van-tag plain type="danger" v-if="item.leaveState == 2"
            >已拒绝</van-tag
          > -->
        </div>
      </div>
      <div v-else>
        <van-empty description="暂无数据" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      list: [],
    }
  },
  mounted() {
    // this.getAccessList(0)
    this.getList()
  },
  computed: {
    personType() {
      return JSON.parse(localStorage.getItem('userInfo')).personType
    },
  },
  methods: {
    getList() {
      this.list = []
      Promise.all([
        this.getAccessList(0),
        this.getAccessList(1),
        this.getAccessList(2),
      ]).then((res) => {
        console.log(res)
        // res.forEach((item) => {
        //   this.list.push(item)
        // })
        res.forEach((item) => {
          if (item) {
            item.forEach((v) => {
              this.list.push(v)
            })
          }
        })
      })
    },
    async getAccessList(state) {
      const { data, code } = await this.$https.getAccessList({
        // pickUpState: state,
        status: state,
        personType: this.personType,
        userId: this.$store.state.userId,
        schoolId: this.$store.state.schoolId,
      })
      if (code !== 200) {
        return false
      }
      return Promise.resolve(data)
    },
    clickLeaveDetail(item) {
      this.$router.push({
        path: '/accessDetail',
        query: { ...item, type: 'au' },
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.leave-list-wrap {
  .leave-list-title {
    color: #78849e;
    font-size: 0.75rem;
    margin: 1rem;
  }
  .leave-list {
    border-radius: 0.75rem;
    border-radius: 1.0625rem;
    margin: 1rem;
    box-shadow: 0rem 1rem 1rem rgba(69, 91, 99, 0.1);
    overflow: hidden;
    .leave-list-item {
      display: flex;
      /* align-items: center; */
      flex-direction: column;
      padding: 0.75rem;

      background: #fff;
      font-size: 0.75rem;
      color: rgba(120, 132, 158, 1);
      border-bottom: 1px solid #f4f4f6;
      .c-left {
        flex: 1;
      }
      .c-right {
        width: 2.6875rem;
        height: 2.6875rem;
        text-align: center;
        line-height: 2.6875rem;
        font-size: 0.75rem;
        border-radius: 0.5rem;
        color: #fff;
        margin-left: 0.3rem;
        box-shadow: 0 0.75rem 1rem rgba(69, 91, 99, 0.1);
        background: #3acce1;
        /* width: 1.5rem;
        height: 1.5rem; */
      }
      .cause {
        font-size: 1rem;
        font-weight: bold;
        color: #333;
        margin-bottom: 0.55rem;
        .status {
          color: #1989fa;
          font-size: 0.85rem;
        }
      }
      .date {
        margin-bottom: 0.55rem;
        & > span:first-child {
          width: 4rem;
          display: inline-block;
          text-align: right;
        }
      }
    }
  }
}
</style>
